(ns manage.adset.ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/ListItemButton$default" :as ListItemButton]
            ["@mui/material/ListItemIcon$default" :as ListItemIcon]
            ["@mui/material/ListItemText$default" :as ListItemText]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Radio$default" :as Radio]
            ["@mui/material/Select$default" :as Select]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.string :as str]
            [common.flags :refer [use-flag]]
            [common.form :as form]
            [common.ocp.view :refer [defocp ocp]]
            [common.util :refer [spread-props]]
            [common.widgets.daterange-picker :as picker]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field hint]]
            [common.widgets.input :refer [input]]
            [common.widgets.meta-alerts :refer [meta-connection-alert]]
            [manage.adset-decision-tree-page.view.common :refer [id-input]]
            [manage.adset.ocp.hooks :as hooks]
            [manage.adset.util :as adset-util]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :refer [$ defui]]))

(def shortcuts-items
  [{:id "30-days"
    :label "30 days"
    :getValue (fn [value]
                (let [[start _] value
                      end (-> start (.clone) (.add 30 "days"))]
                  #js [start end]))
    :isDisabled (fn [value]
                  (let [[start _] value]
                    (nil? start)))}
   {:id "60-days"
    :label "60 days"
    :getValue (fn [value]
                (let [[start _] value
                      end (-> start (.clone) (.add 60 "days"))]
                  #js [start end]))
    :isDisabled (fn [value]
                  (let [[start _] value]
                    (nil? start)))}
   {:id "90-days"
    :label "90 days"
    :getValue (fn [value]
                (let [[start _] value
                      end (-> start (.clone) (.add 90 "days"))]
                  #js [start end]))
    :isDisabled (fn [value]
                  (let [[start _] value]
                    (nil? start)))}
   {:id "6-months"
    :label "6 months"
    :getValue (fn [value]
                (let [[start _] value
                      end (-> start (.clone) (.add 6 "months"))]
                  #js [start end]))
    :isDisabled (fn [value]
                  (let [[start _] value]
                    (nil? start)))}
   {:id "1-year"
    :label "1 year"
    :getValue (fn [value]
                (let [[start _] value
                      end (-> start (.clone) (.add 1 "year"))]
                  #js [start end]))
    :isDisabled (fn [value]
                  (let [[start _] value]
                    (nil? start)))}])

(defui ocp-footer
  [{:keys [step on-cancel on-back is-submitting?]}]
  ($ Stack
     {:direction "row"
      :gap 1
      :sx #js {:justifyContent "flex-end"
               :width "100%"}}
     ($ Button
        {:variant "outlined"
         :color "primary"
         :type "button"
         :onClick (if (= step :step2) on-back on-cancel)
         :sx #js {:px 3 :py 1}}
        (if (= step :step2) "Back" "Cancel"))
     ($ Button
        {:variant "contained"
         :type "submit"
         :disabled is-submitting?
         :sx #js {:px 3 :py 1}}
        (if (= step :step2) "Create" "Next"))))

(defui channel-list [{:keys [options selected on-change]}]
  ($ Stack
     {:gap 1}
     (for [{chan-value :value chan-label :label} options]
       ($ ListItemButton
          {:key chan-value
           :onClick #(on-change chan-value)
           :sx #js {:border "1px solid"
                    :borderColor (if (= selected chan-value) "primary.main" "divider")
                    :borderRadius 1
                    :py 1.5
                    :px 2}}
          ($ ListItemIcon
             {:sx #js {:minWidth 36}}
             ($ adset-util/channel-icon {:channel chan-value}))
          ($ ListItemText
             {:primary chan-label
              :primaryTypographyProps #js {:fontWeight (when (= selected chan-value) "bold")}})
          ($ Radio
             {:checked (= selected chan-value)
              :size "small"
              :tabIndex -1
              :disableRipple true})))))

(defui step1-body [{:keys [control workflow-options]}]
  (let [channel-options (hooks/use-channel-options)]
    ($ Stack
       {:gap 3
        :sx #js {:py 2}}
       ($ form-field
          {:label "Name"
           :required? true}
          ($ form/form-text-field
             {:name "name"
              :control control
              :label ""
              :field-props {:placeholder "Type a short and brief name"
                            :autoFocus true
                            :fullWidth true
                            :hiddenLabel true
                            :inputProps {:data-testid "adset-name-input"}}}))
       ($ rhf/Controller
          {:name "channel"
           :control control
           :render (fn [^js props]
                     (let [{{:keys [error]} :fieldState
                            {:keys [value onChange]} :field} (->clj props)]
                       ($ form-field
                          {:label "Channel"
                           :required? true
                           :err-msg (form/error-message error)}
                          ($ channel-list
                             {:options channel-options
                              :selected value
                              :on-change onChange}))))})
       (when (> (count workflow-options) 1)
         ($ rhf/Controller
            {:name "workflow"
             :control control
             :render (fn [^js props]
                       (let [props-clj (->clj props)
                             {{:keys [error]} :fieldState
                              {:keys [value onChange ref]} :field} props-clj]
                         ($ form-field
                            {:label "Workflow"
                             :required? true
                             :err-msg (form/error-message error)}
                            ($ Select
                               (spread-props (:field props-clj)
                                             {:value (or value "")
                                              :size "small"
                                              :onChange (fn [^js event]
                                                          (onChange (-> event .-target .-value)))
                                              :renderValue (fn [val]
                                                             (let [{:keys [label icon]} (first (filter #(= (:value %) val) workflow-options))]
                                                               ($ Stack #js {:direction "row" :gap 1}
                                                                  ($ Icon icon)
                                                                  ($ Typography nil label))))
                                              :sx #js {:width "100%"}
                                              :data-testid "adset-workflow-select"}
                                             (when ref {:ref ref}))
                               (for [w workflow-options]
                                 ($ MenuItem {:key (:value w)
                                              :value (:value w)}
                                    ($ ListItemIcon ($ Icon (:icon w)))
                                    (:label w))))
                            ($ hint "Which workflow do you want to use to configure your adset?"))))})))))

(defui meta-fields [{:keys [control]}]
  (let [{:keys [account-options accounts-loading? facebook-options instagram-options
                page-ig-loading? account-selected? campaigns-data campaigns-loading?]}
        (hooks/use-adset-create-meta-fields control)]
    (if (and (not accounts-loading?) (empty? account-options))
      ($ meta-connection-alert)
      ($ Stack
         {:spacing 2}
         ($ form-field
            {:label "Meta AD Account Id"
             :required? false}
            ($ rhf/Controller
               {:name "facebookAdAccountId"
                :control control
                :render (fn [^js props]
                          (let [{{:keys [value onChange onBlur]} :field} (->clj props)]
                            (r/as-element
                             [dropdown {:options account-options
                                        :value (or value "")
                                        :loading accounts-loading?
                                        :on-change onChange
                                        :on-blur onBlur
                                        :disable-portal false
                                        :placeholder "Select ad account"}])))}))
         (when account-selected?
           ($ :<>
              ($ id-input {:name "facebookPageId"
                           :label "Facebook Page Id"
                           :required false
                           :control control
                           :loading page-ig-loading?
                           :ids-with-description facebook-options})
              ($ id-input {:name "instagramUserId"
                           :label "Instagram User Id"
                           :required false
                           :control control
                           :loading page-ig-loading?
                           :ids-with-description instagram-options})
              ($ id-input {:name "facebookCampaignId"
                           :label "Meta Campaign Id"
                           :required false
                           :control control
                           :loading campaigns-loading?
                           :ids-with-description campaigns-data})))))))

(defui step2-body [{:keys [control channel]}]
  (let [country-options (hooks/country-options channel)
        automated-activation? (use-flag :automated-activation)
        social-adset? (contains? #{"meta" "tiktok"} channel)]
    ($ Stack
       {:gap 3
        :sx #js {:py 2}}
       ($ rhf/Controller
          {:name "countries"
           :control control
           :render (fn [^js props]
                     (let [props-clj (->clj props)
                           {{:keys [error]} :fieldState
                            {:keys [value onChange onBlur]} :field} props-clj
                           multi? (not= channel "ctv")
                           value-clj (->clj value)]
                       ($ form-field
                          {:label "Region"
                           :required? (= channel "ctv")
                           :err-msg (form/error-message error)}
                          (r/as-element
                           [dropdown {:options country-options
                                      :multi? multi?
                                      :render-checkboxes? multi?
                                      :value (if multi?
                                               (or (seq value-clj) [])
                                               (or (first value-clj) ""))
                                      :on-change (fn [v]
                                                   (onChange (->js (if multi?
                                                                     (if (sequential? v) v [v])
                                                                     [v]))))
                                      :on-blur onBlur
                                      :disable-portal false
                                      :placeholder (when (and multi? (empty? value-clj))
                                                     "Global")}]))))})
       ($ Divider)
       ($ rhf/Controller
          {:name "plannedDates"
           :control control
           :render (fn [^js props]
                     (let [props-clj (->clj props)
                           {{:keys [error]} :fieldState
                            {:keys [value onChange onBlur onFocus]} :field} props-clj]
                       ($ form-field
                          {:label "Planned dates"
                           :required? true
                           :err-msg (form/error-message error)}
                          ($ picker/daterange-picker
                             {:value (->clj value)
                              :onChange onChange
                              :onBlur onBlur
                              :onFocus onFocus
                              :shortcuts shortcuts-items
                              :placeholder "Select start date - Select duration"
                              :disablePast true
                              :slotProps #js {:layout #js {:sx #js {".MuiPickersLayout-shortcuts"
                                                                    #js {:gridArea "2 / 2 / 3"
                                                                         :borderRight "none"
                                                                         :borderLeft "1px solid"
                                                                         :borderColor "grey.70"
                                                                         :paddingLeft "8px"
                                                                         :paddingRight 0}
                                                                    ".MuiPickersLayout-contentWrapper"
                                                                    #js {:gridArea "2 / 1"}}}}}))))})
       ($ rhf/Controller
          {:name "targetImpressions"
           :control control
           :render (fn [^js props]
                     (let [props-clj (->clj props)
                           {{:keys [error]} :fieldState
                            {:keys [value onChange onBlur]} :field} props-clj]
                       ($ form-field
                          {:label "Expected impressions volume"
                           :required? true
                           :err-msg (form/error-message error)}
                          ($ input
                             {:value (if (nil? value) "" (str value))
                              :onChange (fn [^js e]
                                          (let [v (.. e -target -value)]
                                            (onChange (when (seq v) (js/parseInt v 10)))))
                              :onBlur onBlur
                              :type "number"
                              :placeholder "eg. 100,000"
                              :data-testid "adset-target-impressions-input"}))))})
       (when automated-activation?
         ($ adset-util/automated-workflow-switches
            {:control control
             :social-adset? social-adset?}))
       (when (= channel "meta")
         ($ :<>
            ($ Divider)
            ($ meta-fields {:control control}))))))

(defocp adset-ocp :adset/create-adset
  {:width "35%"}
  [{:keys []}]
  (let [{:keys [step on-submit on-back control
                form-control workflow-options is-submitting?]}
        (hooks/use-adset-create-form)

        channel (->clj (rhf/useWatch #js {:control control :name "channel"}))]
    ($ rhf/FormProvider (->js form-control)
       ($ ocp
          {:title "Create a new adset"
           :footer ($ ocp-footer
                      {:step step
                       :on-cancel #(rf/dispatch [:ocp/close {:id :adset/create-adset}])
                       :on-back on-back
                       :is-submitting? is-submitting?})
           :on-submit on-submit}
          (if (= step :step2)
            ($ step2-body {:control control :channel channel})
            ($ step1-body {:control control :workflow-options workflow-options}))))))
